// @flow

export const
  yellowOrange  = '#ffb018',
  deepSkyBlue   = '#0c75ff',
  pattensBlue   = '#d1e5fe',
  appleGreen    = '#7ed321',
  nearLime      = '#4ac960',
  blueGrey      = '#9799a2',
  greyWhisper   = '#ededed',
  brightGrey    = '#74757c',
  redPink       = '#ff1e70',
  dark          = '#303446',
  darkAstronaut = '#40516e',
  paleBlue      = '#e8f2ff',
  lightGrey     = '#d3d3d3',
  whiteGrey     = '#e4e4e4',
  paleGrey      = '#9098a9',
  apricot       = '#ffbe6d',
  red           = '#e4544f',
  neonRed       = '#ff1330',
  cinnabar      = '#dd4242',
  white         = '#ffffff',
  pineCone      = '#8499b2',
  success       = '#5cb85c',
  slateGrey     = '#5c6675',
  violet        = '#8000FF',
  gainsboro     = '#dadada';
